import { Fade, Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { Accommodation } from '../../types/accommodation'
import UserRowSkeleton from './AccommodationRow.skeleton'
import UserRowMobile from './AccommodationRowMobile'
import useStyles from './styles/AccommodationsTableMobile.styles'

interface AccommodationListProps {
  data: Accommodation[]
  loading: boolean
  hasAccessToViewRoomType: boolean | undefined
  hasAccessToViewRatePlan: boolean | undefined
  RoleAccessToViewAccommodationDeatils: boolean | undefined
  RoleAccessToViewImportData: boolean | undefined
}
export const AccommodationsTableMobile: React.FC<AccommodationListProps> = ({
  data,
  loading,
  hasAccessToViewRoomType,
  hasAccessToViewRatePlan,
  RoleAccessToViewAccommodationDeatils,
  RoleAccessToViewImportData
}) => {
  const classes = useStyles()
  return (
    <div>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <UserRowSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singleAccommodation: Accommodation) => (
            <Fade
              in
              timeout={600}
              key={singleAccommodation.basicDetails.propertyCode}>
              <div>
                <UserRowMobile
                  hasAccessToViewRoomType={hasAccessToViewRoomType}
                  hasAccessToViewRatePlan={hasAccessToViewRatePlan}
                  data={singleAccommodation}
                  RoleAccessToViewAccommodationDeatils={
                    RoleAccessToViewAccommodationDeatils
                  }
                  RoleAccessToViewImportData={RoleAccessToViewImportData}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
